import React from 'react';
import {
    LayoutDashboard,
    Building2,
    FileText,
    ClipboardList,
    LogOut,
    X,
} from 'lucide-react';
import type { PageView } from '../../types';
import { Logo } from './Logo';

interface SidebarProps {
    currentPage: PageView;
    onNavigate: (page: PageView) => void;
    onLogout?: () => void;
    isOpen?: boolean;
    onClose?: () => void;
}

const navItems: { id: PageView; label: string; icon: React.ElementType }[] = [
    { id: 'dashboard', label: 'סקירה כללית', icon: LayoutDashboard },
    { id: 'instances', label: 'קבוצות סקרים', icon: ClipboardList },
    { id: 'organizations', label: 'ארגונים', icon: Building2 },
    { id: 'templates', label: 'תבניות סקר', icon: FileText },
];

export const Sidebar: React.FC<SidebarProps> = ({ currentPage, onNavigate, onLogout, isOpen, onClose }) => {
    return (
        <aside className={`sidebar ${isOpen ? 'open' : ''}`}>
            <div className="sidebar-header">
                <div className="sidebar-logo">
                    <Logo style={{ width: '100%', height: 'auto', maxHeight: '64px' }} />
                </div>
                <button
                    className="btn btn-icon btn-ghost sidebar-close-btn"
                    onClick={(e) => {
                        e.stopPropagation();
                        if (onClose) onClose();
                    }}
                    style={{ position: 'absolute', left: 'var(--space-4)', top: 'var(--space-4)', color: 'white', zIndex: 10 }}
                >
                    <X size={24} />
                </button>
            </div>

            <nav className="sidebar-nav">
                <div className="nav-section">
                    <div className="nav-section-title">ניהול</div>
                    {navItems.map((item) => {
                        const Icon = item.icon;
                        return (
                            <button
                                key={item.id}
                                className={`nav-item ${currentPage === item.id ? 'active' : ''}`}
                                onClick={() => onNavigate(item.id)}
                                style={{ width: '100%', textAlign: 'right', border: 'none', background: 'transparent', display: 'flex', alignItems: 'center' }}
                            >
                                <Icon size={20} className="nav-item-icon" />
                                <span className="nav-item-label">{item.label}</span>
                            </button>
                        );
                    })}
                </div>

                <div className="nav-section" style={{ marginTop: 'auto' }}>
                    <button
                        className="nav-item"
                        onClick={onLogout}
                        style={{ width: '100%', textAlign: 'right', display: 'flex', alignItems: 'center', border: 'none', background: 'transparent' }}
                    >
                        <LogOut size={20} className="nav-item-icon" />
                        <span className="nav-item-label">יציאה</span>
                    </button>
                </div>
            </nav>
        </aside>
    );
};
